/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HealthFindrBaseService } from '../health-findr-base-service';
import { HealthFindrApiConfiguration } from '../health-findr-api-configuration';
import { HealthFindrStrictHttpResponse } from '../health-findr-strict-http-response';

import { apiSystemSpecialityGroupGet } from '../fn/system-speciality-group/api-system-speciality-group-get';
import { ApiSystemSpecialityGroupGet$Params } from '../fn/system-speciality-group/api-system-speciality-group-get';
import { SystemSpecialityGroupViewModel } from '../models/system-speciality-group-view-model';

@Injectable({ providedIn: 'root' })
export class HealthFindrSystemSpecialityGroupService extends HealthFindrBaseService {
  constructor(config: HealthFindrApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSystemSpecialityGroupGet()` */
  static readonly ApiSystemSpecialityGroupGetPath = '/api/SystemSpecialityGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSystemSpecialityGroupGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSystemSpecialityGroupGet$Response(params?: ApiSystemSpecialityGroupGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SystemSpecialityGroupViewModel>>> {
    return apiSystemSpecialityGroupGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSystemSpecialityGroupGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSystemSpecialityGroupGet(params?: ApiSystemSpecialityGroupGet$Params, context?: HttpContext): Observable<Array<SystemSpecialityGroupViewModel>> {
    return this.apiSystemSpecialityGroupGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<SystemSpecialityGroupViewModel>>): Array<SystemSpecialityGroupViewModel> => r.body)
    );
  }

}
